import { Injectable } from '@angular/core';

declare let bulk_donation_hf_mini_AB;
declare let desktop_tip_AB;
declare let slab_AB;
declare let kcart_tip_story_AB; // (vwo.kcart_tip_story_AB() && vars.showKCart) remove in tip comp after result
declare let kcart_slab_AB;
declare let kcart_not_preselected_AB;
declare let kettokart_utm_pricechange_AB;
declare let surrogate_brand_AB;
declare let insta_share_AB;
declare let new_upi_AB;

@Injectable({
  providedIn: 'root'
})
export class ABService {

  bulk_donation_hf_mini_AB() {
    if (typeof bulk_donation_hf_mini_AB !== 'undefined') {
      return bulk_donation_hf_mini_AB;
    }
  }

  desktop_tip_AB() {
    if (typeof desktop_tip_AB !== 'undefined') {
      return desktop_tip_AB;
    }
  }

  slab_AB() {
    if (typeof slab_AB !== 'undefined') {
      return slab_AB;
    }
  }

  kcart_tip_story_AB() {
    if (typeof kcart_tip_story_AB !== 'undefined') {
      return kcart_tip_story_AB;
    }
  }

  kcart_slab_AB() {
    if (typeof kcart_slab_AB !== 'undefined') {
      return kcart_slab_AB;
    }
  }

  kcart_not_preselected_AB() {
    if (typeof kcart_not_preselected_AB !== 'undefined') {
      return kcart_not_preselected_AB;
    }
  }

  kettokart_utm_pricechange_AB() {
    if (typeof kettokart_utm_pricechange_AB !== 'undefined') {
      return kettokart_utm_pricechange_AB;
    }
  }

   surrogate_brand_AB() {
    if (typeof surrogate_brand_AB !== 'undefined') {
      return surrogate_brand_AB;
    }
  }

  insta_share_AB() {
    if (typeof insta_share_AB !== 'undefined') {
      return insta_share_AB;
    }
  }

  new_upi_AB() {
    const sessionData = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('new_upi_AB') : undefined;
    if (sessionData) {
      return sessionData;
    }
    if (typeof new_upi_AB !== 'undefined') {
      sessionStorage.setItem('new_upi_AB', new_upi_AB);
      return new_upi_AB;
    }
  }
}
